import '../../../core/components/chart-grid/ChartGrid.css';
import './HistogramOverlays.css';
export var crosshairLayout = '_drl8ns1-3-5-0 _13lzg4k0-3-5-0';
export var datapointLayout = '_drl8ns0-3-5-0 _13lzg4k0-3-5-0';